import {
	getController,
	type HpRequestOptional,
	apiService as Service,
} from '@/services/service'

const url = 'journals'

export const journalService = {
	...getController<Api.Journal, Api.JournalPostInput, Api.JournalPostInput>(
		url
	),

	review: ({ id, data }: { id: number; data: HpRequestOptional }) =>
		Service.post({ url: `${url}/${id}/review`, data }),

	/**
	 * Eigenes Urteil zu einer Buchung zurücknehmen — sie ist danach wieder
	 * ungeprüft. Die Belegprüfung steht in der Abfrage statt im Rumpf: DELETE
	 * trägt hier keinen Rumpf (siehe Service.delete).
	 */
	withdrawReview: ({
		id,
		reviewDocumentId,
	}: {
		id: number
		reviewDocumentId: number
	}) =>
		Service.delete({
			url: `${url}/${id}/review?review_document_id=${reviewDocumentId}`,
		}),
}

export default journalService
